//@import dependencies
import React, {useEffect, useState, CSSProperties} from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Link, useHistory, useLocation } from 'react-router-dom'
//@end

import { customs } from 'app_config/globals';

//@import components
import AcademicOfferModuleSkeleton from 'app_components/modules/academic/academicOffer/components/academicOfferModuleSkeleton';
import OfferCardComponent from 'app_components/commons/offercard'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import PaginationComponent from 'app_components/commons/pagination'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import IconComponent from 'app_components/commons/icons';
import FilterCourses from 'app_components/modules/FilterCourses/FilterCourses';
import { AiOutlineCloseCircle } from 'react-icons/ai'
import CategoriesModule from 'app_components/modules/academic/categories'
import { CiSearch } from "react-icons/ci";
//@end

// @import hooks
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { TypesSelectFilterAcademicOffer } from '../containers/academicOfferModule';
// @end

// @INFO Import services
// import CourseModeService from 'app_services/campus/academic/courseModeService'
// import CourseSchedulingModeMasterService from 'app_services/admin/courseScheduling/courseSchedulingModeMasterService'
import CourseSchedulingModeService from 'app_services/admin/courseScheduling/courseSchedulingModeService'
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../academicOfferModule.scss'
import DropDownComponent from 'app_components/commons/DropDownComponent/DropDownComponent';
import InputComponent from 'app_components/commons/Input/InputComponent';

// @ADD Component types
interface IAcademicOfferModuleLayoutProps {
	courses: Array<any>
  status: null | 'loading' | 'error'
  selectFilter?: TypesSelectFilterAcademicOffer
  onFilterChange: (params: any) => void
  showPagination?: boolean
  pagination?: IPagination
  onPageChange?: (page: number) => void
  onClearFilters?: () => void
  showCategories?: boolean
  onHandleCategory?: (category: any) => void
  handleClickItemFilter: (type?: TypesSelectFilterAcademicOffer) => void
  filterState: any
  handleChangeSearch: (search: string) => void
  handleOnSearch: () => void
}

const AcademicOfferModuleLayout: React.FC<IAcademicOfferModuleLayoutProps> = (props) => {

  // const courseModeService: CourseModeService = new CourseModeService()
  // const courseSchedulingModeMasterService: CourseSchedulingModeMasterService = new CourseSchedulingModeMasterService()
  const courseSchedulingModeService: CourseSchedulingModeService = new CourseSchedulingModeService()

  const [listOfCourseModes, setListOfCourseModes] = useState<Array<any>>([])
  const [openFilter, updateOpenFilter] = useState<boolean>(false)
  const [openCategoryFilter, updateOpenCategoryFilter] = useState<boolean>(false)
  const { windowWidth } = useWindowWidth()
  const formHook = useForm()
  const location = useLocation()
  const history = useHistory()

  const modularSpy = formHook.watch('modular')

  const { t } = useTranslation()

  useEffect(() => {
    const initialConfig = async () => {
      await getCourseModes()
      formHook.register('modular', { required: false })
      setDefaultState()
    }
    initialConfig()
  }, [])

  const setDefaultState = () => {
    const state = location.state;
    if (state && typeof state === 'object') {
      Object.keys(state).forEach((key: string) => {
        // @ts-ignore
        formHook.setValue(key, state[key])
      })
      history.replace(location.pathname, undefined)
      props.onFilterChange(formHook.getValues())
    }
  }

  const getCourseModes = async () => {
    const types: Array<any> = []
    const courseModesResponse = await courseSchedulingModeService.listExternal({moodle_id: true})
    if (courseModesResponse) {
      courseModesResponse.courseSchedulingModes.map((type: any) => {
        types.push({ value: type._id, label: type.name })
      })
    }
    setListOfCourseModes(types)
  }

  const clearForm = () => {
    formHook.reset()
    formHook.register('modular', { required: false })
    if (props.onClearFilters) {
      props.onClearFilters()
    }
  }

  const onHandleCategory = (category: any) => {
    formHook.setValue('modular', category._id)
    props.onFilterChange(formHook.getValues())
  }

  return(
    <>
      {props.showCategories && windowWidth > 991 && (
        <>
          <CategoriesModule container="section" currentCategory={modularSpy} onHandleCategory={onHandleCategory} />
        </>
      )}
      <div
        className={'content-offer'}
      >

        <FilterCourses
          clearForm={clearForm}
          listOfCourseModes={listOfCourseModes}
          onFilterChange={props.onFilterChange}
          formHook={formHook}
          className='filter-desktop'
        />

        <div className={'content-results'}>
          <div className='academic-offer--search-input-container'>
            <CiSearch />
            <InputComponent
              placeholder='Buscar en tienda'
              className='academic-offer--search-input'
              onEnter={props.handleOnSearch}
              onChange={(e) => props.handleChangeSearch(e.target.value)}
              value={props.filterState?.search ? props.filterState?.search : ''}
            />
          </div>
          <span className={'oferta-academica font-title-bold'}>{t('modules.academic_offer.content.title')}</span>
          <p className="academic-offer-body">{t('modules.academic_offer.content.body')}</p>
          <ButtonComponent
            variant='secondary'
            style={{ marginBottom: '10px' }}
            className='button-filter-movil'
            onClick={() => updateOpenFilter(!openFilter)}
          >
            <ButtonComponent.Icon>
              <IconComponent
                width='1rem'
                svg='Filter'
              />
            </ButtonComponent.Icon>
            Filtrar
          </ButtonComponent>
          {props.showCategories && windowWidth <=  991 && (
            <>
              <ButtonComponent
                variant='secondary'
                style={{ marginBottom: '10px' }}
                className='button-categories-movil'
                onClick={() => updateOpenCategoryFilter(!openFilter)}
              >
                <ButtonComponent.Icon>
                  <IconComponent
                    width='1rem'
                    svg='Filter'
                  />
                </ButtonComponent.Icon>
                Categorias
              </ButtonComponent>
              <MovilFilterContainer
                open={openCategoryFilter}
                onClose={() => updateOpenCategoryFilter(false)}
              >
                <CategoriesModule container="modal-category" currentCategory={modularSpy} onHandleCategory={(data) => {
                  onHandleCategory(data);
                  updateOpenCategoryFilter(false)
                }} />
              </MovilFilterContainer>
            </>
          )}
          {windowWidth <=  991 ?
            <MovilFilterContainer
              open={openFilter}
              onClose={() => updateOpenFilter(false)}
            >
              <FilterCourses
                clearForm={clearForm}
                listOfCourseModes={listOfCourseModes}
                onFilterChange={props.onFilterChange}
                formHook={formHook}
                style={{ color: 'black' }}
              />
            </MovilFilterContainer>
          :null}
          <div className={''}>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'flex-end'
              }}
            >
              <DropDownComponent
                title={props.selectFilter ? props.selectFilter : 'Ordenar por'}
              >
                <DropDownComponent.Item
                  onClick={() => props.handleClickItemFilter(undefined)}
                >
                  Ordenar por
                </DropDownComponent.Item>
                <DropDownComponent.Item
                  onClick={() => props.handleClickItemFilter('Menor a mayor precio')}
                >
                  Menor a mayor precio
                </DropDownComponent.Item>
                <DropDownComponent.Item
                  onClick={() => props.handleClickItemFilter('Mayor a menor precio')}
                >
                  Mayor a menor precio
                </DropDownComponent.Item>
                <DropDownComponent.Item
                  onClick={() => props.handleClickItemFilter('Mayor promoción')}
                >
                  Mayor promoción
                </DropDownComponent.Item>
              </DropDownComponent>
            </div>
            {props.status === 'loading' ? (
              <AcademicOfferModuleSkeleton />
            ) : (
              <>
                {props.courses && props.courses.length > 0 ? (
                  <>
                  <div className={'content-courses'}>
                    {props.courses.map((course) => (
                      <div key={course.key}>
                        <OfferCardComponent
                          course={course}
                          list={windowWidth < 991 ? true : false }
                          link={routingService.getPublicPath(`/curso/${course._id}`)}
                          share={`${customs.site}/curso/${course._id}`}
                        />
                      </div>
                    ))}
                  </div>
                  {!props.showPagination && (
                    <div className="view-more-container">
                      <Link
                        className="btn btn-secondary"
                        to={{
                          pathname: routingService.getPublicPath('/cursos'),
                          state: {
                            ...formHook.getValues()
                          }
                        }}
                        style={{ backgroundColor: '#62B5E5' }}
                      >
                        <span>{t('modules.courses.view_more')} </span>
                      </Link>
                    </div>
                  )}
                  {props.showPagination && props.pagination && (
                    <div className="row">
                      <div className="col-12">
                        <PaginationComponent data={props.pagination} onChangePage={props.onPageChange} />
                      </div>
                    </div>
                  )}
                  </>
                ) : (
                  <div className="content-offer-no-data">
                    <AlertComponent
                      type='warning'
                      title={t('modules.courses.no_data')}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

// ================================================
// @INFO Contenedor del filtro en version movil
// ================================================
interface IMovilFilterContainerProps {
  open: boolean
  className?: string
  style?: CSSProperties
  id?: string
  children?: any
  onClose?: ()=> any
}

const MovilFilterContainer: React.FC<IMovilFilterContainerProps> = (props) => {
  return(
    <div
      className={`movil_filter_container-layout ${props.open ? 'open' : 'close'} ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <div>
        <div
          className="close-icon"
          onClick={props.onClose}
        >
          <AiOutlineCloseCircle/>
        </div>
        {props.children}
      </div>
    </div>
  );
}




export default AcademicOfferModuleLayout
